import React from "react";

const TINTS = ["#1F4D3A", "#1E3557", "#5A1E2A", "#3D2557", "#4F3A1C", "#1E4A4F"];

const initials = (name = "") =>
  name.split(/[\s:\-_]+/).filter(Boolean).slice(0, 3).map((w) => w[0]).join("").toUpperCase() || "MQL";

const hash = (s = "") => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export default function MonogramTile({ name, label, className = "", textSize = "text-5xl", testId }) {
  const tint = TINTS[hash(name) % TINTS.length];
  return (
    <div data-testid={testId} className={`relative overflow-hidden flex items-center justify-center ${className}`}
      style={{ background: `radial-gradient(120% 90% at 85% 10%, ${tint} 0%, #15161A 55%, #101114 100%)` }}>
      <div className="absolute inset-0 opacity-[0.07]"
        style={{ backgroundImage: "repeating-linear-gradient(135deg, #D4AF37 0 1px, transparent 1px 14px)" }} />
      <div className="absolute inset-2 border border-[#D4AF37]/25 rounded-[inherit] pointer-events-none group-hover:border-[#D4AF37]/60 transition-colors duration-500" />
      <span className={`relative ${textSize} font-black tracking-wider bg-gradient-to-b from-[#F2D98D] via-[#D4AF37] to-[#8C6D1F] bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-500`}
        style={{ fontFamily: "'Playfair Display', serif" }}>{initials(name)}</span>
      {label && <span className="absolute bottom-3 left-0 right-0 text-center text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/70">{label}</span>}
    </div>
  );
}
